import styled from '@emotion/styled';
import type { ButtonHTMLAttributes, FunctionComponent, SVGProps } from 'react';

const StyledButton = styled.button`
  align-items: center;
  background: #fff;
  border: 1px solid #949494;
  color: #333333;
  display: flex;
  flex-direction: row;
  font-size: 14px;
  line-height: 16px;
  gap: 12px;
  justify-content: center;
  padding: 12px;
  width: 100%;
  cursor: pointer;
  border-radius: 4px;
  position: relative;
  font-weight: bold;
  svg {
    position: absolute;
    left: 15px;
  }
`;

type SignInButtonProps = {
  dataCy: string;
  onClick: () => void;
  text?: string;
  Logo?: FunctionComponent<
    SVGProps<SVGSVGElement> & {
      title?: string | undefined;
    }
  >;
  dataTestid?: string;
} & ButtonHTMLAttributes<HTMLButtonElement>;

function SignInButton(props: SignInButtonProps): JSX.Element {
  const { dataCy, onClick, text, Logo, dataTestid, ...rest } = props;
  return (
    <StyledButton
      data-cy={dataCy}
      onClick={onClick}
      data-testid={dataTestid}
      {...rest}
    >
      {Logo && <Logo title={text} />}
      {text}
    </StyledButton>
  );
}

export { SignInButton };
